import { lazy } from 'react'

export const ProjectCreateContainerLazy = lazy(
	() => import('Pages/knowledge/project/components/ProjectEdit')
)
export const ProjectEditContainerLazy = lazy(
	() => import('Pages/knowledge/project/components/ProjectEdit')
)
export const ProjectViewContainerLazy = lazy(
	() => import('Pages/knowledge/project/components/ProjectList/ProjectView')
)

export const KnowledgeConnectedLazy = lazy(
	() => import('Pages/knowledge/project/components/ProjectList/Knowledge')
)
